export default function GlobalBottomCta() {
  return (
    <section className="py-16 md:py-20 bg-redbean-primary">
      <div className="mx-auto px-4 md:px-6 lg:px-8 text-center" style={{ maxWidth: "800px" }}>
        <h2
          className="font-heading font-bold text-redbean-cream mb-3"
          style={{ fontSize: "clamp(1.5rem, 3vw, 2.125rem)", lineHeight: 1.4 }}
        >
          想訂購、合作或了解加盟？
        </h2>
        <p
          className="text-redbean-cream/80 mb-8"
          style={{ fontSize: "1.1875rem", lineHeight: 1.75 }}
        >
          歡迎加入 LINE（@214epvsm）或填寫表單，讓來加綉綉依你的需求提供最適合的產品、宅配、禮盒或加盟資訊。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="https://lin.ee/xiNNjjf"
            rel="nofollow"
            target="_blank"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-redbean-gold text-redbean-coffee font-semibold rounded-full hover:bg-redbean-cream transition-colors whitespace-nowrap text-[1.0625rem] min-h-[44px] cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-chat-3-line" />
            </span>
            加入 LINE 詢問
          </a>
          <a
            href="https://readdy.ai/api/form/d7u6ps39spvbtqoimkrg"
            rel="nofollow"
            data-readdy-form
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-redbean-cream text-redbean-cream font-semibold rounded-full hover:bg-redbean-cream hover:text-redbean-coffee transition-colors whitespace-nowrap text-[1.0625rem] min-h-[44px]"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-edit-line" />
            </span>
            填寫聯絡表單
          </a>
        </div>
      </div>
    </section>
  );
}